import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from './common.js'
import {
  getChannelList_mock,
  getSku2Channel_mock,
  queryOrderStatus_mock,
  queryOrderList_mock,
} from './mock'
import { getUvid } from '@/utils/uvid'
import { getFissionParams } from './fission'
import { globalVariable } from '@/utils/exportVariable'
import { getServerHost } from '@/utils/host'
import { compressBannerImg } from '@/utils/webp'
import { region } from '@/utils/utils'

/**
 * 此文档主要是直连支付通道的游戏：igg，pubgm
 */

const http_request_mode = 'http' // 是否启用mock

/***
 * 下单
 * email 用户email
 * channelId 通道id
 * channelName 通道名
 * channel 支付渠道名
 * subChannel 支付子渠道名。注：没有就不传
 * skuId 套餐id
 * skuName 套餐名称
 * game 游戏名称
 * country 国家类型
 * source 业务渠道
 * payPrice 支付价格
 * sign 签名验证码
 */
export function placeOrder(options = {}, useMock = false) {
  if (useMock) {
    return Promise.reject({
      code: 1207,
    })
  }
  options = {
    uvid: getUvid(),
    ...options,
    ...getFissionParams(),
  }
  return request.postJson({
    url: appendApiUrl('/order/create/order'),
    data: { ...deleteEmpty(options) },
  })
}
/***
 * 商品(套餐)信息查询接口
 * skuId 套餐id
 * game 游戏名称
 * country 国家代码
 * status -1全部，0下架，1上架
 * sign 签名验证码
 */
export function getSkuList(options) {
  return request.post(
    {
      url: appendApiUrl('/config/query/sku'),
      data: { ...deleteEmpty(options) },
    },
    { showLoading: false }
  )
}

/***
 * 商品(套餐)信息查询接口【分类】
 * 使用范围：GOK
 *
 * game 游戏名称
 * country 国家代码
 * status -1全部，0下架，1上架
 * sign 签名验证码
 */
export function getCategorySku(options) {
  return request.post({
    url: appendApiUrl('/config/query/category/sku'),
    data: { ...deleteEmpty(options) },
  })
}

/***
 * 通道信息查询接口
 * channelId 通道id
 * company 支付公司
 * country 国家代码
 * status -1全部，0下架，1上架
 * sign 签名验证码
 */
export function getChannelList(options, game, skuId) {
  // game = 'pubgm'
  if (http_request_mode === 'mock' || game === 'pubgm') {
    return getChannelList_mock().filter(
      (item) => item.game === game && item.skuId === skuId + ''
    )
  }
  return request.post(
    {
      url: appendApiUrl('/config/query/channel'),
      data: { ...deleteEmpty(options) },
    },
    { showLoading: false }
  )
}
/***
 * 通道套餐关系查询接口
 * channelId 通道id
 * skuId 商品id
 * game 游戏名称
 * status -1全部，0下架，1上架
 * sign 签名验证码
 */
export function getSku2Channel(options) {
  if (http_request_mode === 'mock') {
    return getSku2Channel_mock()
  }
  return request.post(
    {
      url: appendApiUrl('/config/query/sku-channel'),
      data: { ...deleteEmpty(options) },
    },
    { showLoading: false }
  )
}
/***
 * 订单状态查询接口
 * orderNo 订单号
 * kicoinId: ki币用户 ID
 * sign 签名验证码
 */
export function queryOrderStatus(options) {
  if (http_request_mode === 'mock') {
    return queryOrderStatus_mock()
  }
  return request.post({
    url: appendApiUrl('/order/query/status'),
    data: { ...deleteEmpty(options) },
  })
}
/***
 * 订单列表查询接口
 * email 邮箱
 * orderNo 订单号
 * platformOrderNo 平台订单号
 * game 游戏名称
 * startTime 查询起始时间，单位s
 * endTime 查询结束时间，单位s
 * sign 签名验证码
 */
export function queryOrderList(options) {
  if (http_request_mode === 'mock') {
    return queryOrderList_mock()
  }
  return request.post({
    url: appendApiUrl('/order/query/list'),
    data: { ...deleteEmpty(options) },
  })
}

/**
 * 游戏服务器获取接口
 * @param {*} options
 * game: Y 游戏名称
 * country: Y 国家代码
 * sign : Y 签名验证码
 * @returns
 */
export const getServerList = (options = {}) => {
  return request.postJson({
    url: appendApiUrl('/config/query/server'),
    data: deleteEmpty(options),
  })
}
// h5获取游戏列表接口
export const getGameList = (options = {}) => {
  return request.postJson({
    url: appendApiUrl('/config/query/game'),
    data: { ...deleteEmpty(options) },
  })
}

// 外部商品通道套餐关系查询接口
export const getOuterChannelList = (options = {}) => {
  return request.postJson(
    {
      url: appendApiUrl('/config/query/outer-sku-channel'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  )
}

// 外部商品(套餐)信息查询接口
export const getExternalOuterSku = (options = {}) => {
  const {
    game = '',
    country = '',
    uid = '',
    cpServerId = '',
    roleId = '',
  } = options
  return request.get({
    url: appendApiUrl(
      `/config/query/outer-sku?game=${game}&country=${country}&uid=${uid}&cpServerId=${cpServerId}&roleId=${roleId}`
    ),
  })
}

// 马来价格不含SST

// export const getExtraConfig = (options = {}) => {
//   return request.postJson(
//     {
//       url: appendApiUrl('/config/query/extra-config'),
//       data: { ...deleteEmpty(options) },
//     },
//     {
//       showLoading: false,
//       showErrorToast: false,
//     }
//   )
// }

// 地区所有支付方式

export const getPayMethod = (options = {}) => {
  return request.postJson(
    {
      url: appendApiUrl('/config/query/country/pay-method'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  )
}

// 详情页查询基础配置接口
export const fetchDetailConfig = async (options = {}, config = {}) => {
  const { cacheFlag = true, showLoading = false } = config
  const store = globalVariable?.store || {}
  const { detail = {} } = store?.state || {}
  const cacheDatas = detail.detailBasicConfig || {}
  if (cacheDatas && Object.keys(cacheDatas).length > 0 && cacheFlag) {
    return cacheDatas
  }
  const result = await request.postJson(
    {
      url: appendApiUrl('/detail-page/query/basic-config'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading,
      showErrorToast: false,
    }
  )

  let detailPageBanners = result?.bannerConfig?.detailPageBanners
  if (detailPageBanners && detailPageBanners.length) {
    result.bannerConfig.detailPageBanners = await compressBannerImg(
      detailPageBanners
    )
  }

  store.commit('detail/setDetailBasicConfig', result)
  return result
}

// https://staging-dev1-oversea-api.toplupe.com/api/doc.html#/default/toplupe%E8%AF%A6%E6%83%85%E9%A1%B5%E6%8E%A5%E5%8F%A3/queryCustomConfigUsingPOST
// warn 查询CMS自定义详情页配置
export function getCustomConfig(options, config, headers = {}) {
  const { renderType = 'server', ssrdata } = config
  const baseObj = { baseURL: ssrdata && getServerHost(ssrdata) }
  const _otherOpt = renderType === 'server' ? baseObj : {}

  return request.postJson(
    {
      url: appendApiUrl('/detail-page/query/custom-config'),
      data: { ...deleteEmpty(options) },
      ..._otherOpt,
    },
    {
      showLoading: false,
      showErrorToast: false,
    },
    headers
  )
}

/**
 * 查询最近一个订单的信息，为了获取上一次绑定的email
 * */
export function queryOrderEmail() {
  return request.postJson({
    url: appendApiUrl('/order/query/latest'),
    data: {
      country: region(),
    },
  })
}
